export function useFreeCancellation(
  trip: MaybeRefOrGetter<Partial<TripParams | Trip | undefined>>,
  cancelConditions: MaybeRefOrGetter<CancelCondition[] | undefined>,
) {
  const confData = useConfdata()

  const freeCancellationRange = computed(() =>
    getFreeCancellationRange(toValue(cancelConditions) ?? []),
  )

  const lastDate = computed<Date | undefined>(() => {
    const checkinDate = toValue(trip)?.checkin as UnparsedDate | undefined

    if (!checkinDate) return undefined

    return daysSub(checkinDate, freeCancellationRange.value)
  })

  const lastDateShort = computed(
    () =>
      lastDate.value &&
      lastDate.value.toLocaleDateString(confData.locale, {
        day: 'numeric',
        month: 'short',
      }),
  )

  const lastDateFull = computed(
    () =>
      lastDate.value &&
      lastDate.value.toLocaleDateString(confData.locale, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
      }),
  )

  const isEnabled = computed(
    () =>
      !!toValue(freeCancellationRange) &&
      isTripValid(toValue(trip)) &&
      lastDate.value &&
      inFuture(lastDate.value),
  )

  return reactive({
    freeCancellationRange,
    lastDate,
    lastDateShort,
    lastDateFull,
    isEnabled,
  })
}
